import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "ルールベース型チャットの限界を超え、RAGを活用した生成AIチャットへ刷新。アジャイル開発とUX/UIデザインを組み合わせ、プロジェクト開始1か月未満でプロトタイプを完成。課題解決率の大幅向上とコンタクトセンターの負荷軽減を実現した大和総研の開発事例です。"

const primaryImage = "https://www.i3design.jp/images/img/cases/dir/ogp_dir.png"

export const dirPageMeta: PageMeta = {
  title: "大和総研 金融向け生成AIチャットの課題解決率を大幅改善｜開発事例 | i3DESIGN",
  description,
  keyword: "事例 実績 生成AI チャット アジャイル開発 RAG",
  image: primaryImage,
  url: `${SITE_URL}/cases/dir/`,
}

export const dirSchema = buildCaseStudySchema({
  slug: "dir",
  pageTitle: dirPageMeta.title,
  description: dirPageMeta.description,
  headline: "課題解決率が大幅向上 - “使える生成AIチャット”をアジャイル×UX/UIでスピード実現",
  alternativeHeadline: "株式会社大和総研",
  primaryImage,
  images: ["https://www.i3design.jp/images/img/cases/dir/ogp_dir.png","https://www.i3design.jp/images/img/cases/dir/mv.webp"],
  clientName: "株式会社大和総研",
  breadcrumbLabel: "課題解決率が大幅向上 - “使える生成AIチャット”をアジャイル×UX/UIでスピード実現",
})
